import PropTypes from "prop-types";
import { Box, Stack, Typography } from "@mui/material";
import { YouTubePlayer } from "../scanner/youtube-player";

export const TutorialScanPlayer = ({ url, onCompletePlayback }) => {
  // Any controls happening on the player itself
  // should not propagate to the parent components.
  const stopSwipePropagation = (event) => event.stopPropagation();

  // The component
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={4}
      sx={{ flex: 1, pt: 4 }}
    >
      <Typography variant="body1" sx={{ color: "text.primary" }}>
        Be sure to follow this scanning procedure.
      </Typography>

      {/* The video player */}
      <Box sx={{ flex: 1, minHeight: 0, width: "100%", px: 3 }}>
        <Box
          onTouchStart={stopSwipePropagation}
          onTouchEnd={stopSwipePropagation}
          sx={{ width: "100%", borderRadius: 4, overflow: "hidden" }}
        >
          <YouTubePlayer
            url={url}
            mute={false}
            onEnded={onCompletePlayback}
            onError={onCompletePlayback} // Assume completed if failed to load
          />
        </Box>
      </Box>
    </Stack>
  );
};

TutorialScanPlayer.propTypes = {
  url: PropTypes.string.isRequired,
  onCompletePlayback: PropTypes.func.isRequired,
};
